module.exports = __webpack_public_path__ + "static/img/xcx.dc30d0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xcx.jpg
// module id = rP9K
// module chunks = 3